import React, { useState, useEffect, useRef, createContext, act } from "react";
import classNames from "classnames";
import { Route, useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import { AppTopbar } from "./AppTopbar";
import { AppMenu } from "./AppMenu";
import { AppConfig } from "./AppConfig";

import Login from "./pages/Login";


import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";

import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "./assets/demo/flags/flags.css";
import "./assets/demo/Demos.scss";
import "./assets/layout/layout.scss";
import "./App.scss";

import { Applications } from "./pages/applications/Applications";
import { Toast } from "primereact/toast";
import LoadingModules from "./componets/Azure/LoadingModules";
import EntraHook from "./componets/Azure/EntraHook";
import { CHANNEL_CATEGORY_UNASSISTED } from "./constants";
import { lookupsService } from "./services/LookupsService";
import { APP_TYPE } from "./config/Config";
import { PoliticalSelfServiceSiteGenerateRoutesAndMenu } from "./App_PoliticalSelfService_Menu";
import { CandidateSiteGenerateRoutesAndMenu } from "./App_Candidate_Menu";
import { PoliticalPartyDBContext } from "./pages/politicalParty/PoliticalPartyDBContext";
import { CentalSiteGenerateRoutesAndMenu } from "./App_Central_Site_Menu";
import { CandidateManagement } from "./pages/CandidateManagement/CandidateManagement";
import { CandidateDBContext } from "./pages/CandidateManagement/CandidateDBContext";
import { LanguageContext, LanguageControl } from "./componets/Language/LanguageControl";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Objections } from "./pages/Objections";
import { AppFooter } from "./AppFooter";
import { ResultManagementGenerateRoutesAndMenu } from "./App_ResultManagement_Menu";
export var AppDB = createContext()

function ScreenLoader({ children, setCurrentApplicationScreen, screenType = "", setPermission, action, subModules, setGlobalDelimitation }) {
    const location = useLocation();
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        var isDoNotClearDelimitations = false;
        queryParams.forEach((_, key) => {
            if ('dnc-delimitations' === key) {
                isDoNotClearDelimitations = true;
            }
        });
        if (!isDoNotClearDelimitations) {
            setGlobalDelimitation({})
        }

        if (setPermission) {

            setPermission(prev => ({
                ...prev,
                actions: action, subModules: subModules, currentTab: "", currentScreen: "", Create: false, Read: false, Update: false, Approve: false, Reject: false,
                Recommend: false,
                Withdraw: false
            }))
        }
        if (setCurrentApplicationScreen) {
            setCurrentApplicationScreen(screenType);
        }
    }, []);

    return <>{children}</>;
}


const App = ({ instance }) => {
    const [refreshingApplication, seRefreshingApplication] = useState(false)
    const [permission, setPermission] = useState({})
    const [currrentApplicationScreen, setCurrrentApplicationScreen] = useState("")
    const [layoutMode, setLayoutMode] = useState("static");
    const [layoutColorMode, setLayoutColorMode] = useState("light");
    const [inputStyle, setInputStyle] = useState("outlined");
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const [isIecEdit, setIsIecEdit] = useState(true);
    var [applicationName, setApplicationName] = useState("IEC Elector Management");
    const [lookUp, setLookUp] = useState([]);
    const copyTooltipRef = useRef();
    const location = useLocation();

    var [globalDelimitation, setGlobalDelimitation] = useState({})
    var [finalUserMenu, setFinalUserMenu] = useState({ menu: [], routes: {} })
    var [refresh_politicalParties, setRefresh_PoliticalParties] = useState(false);
    var [menuRootName, setMenuRootName] = useState("");
    const toast = useRef(null);
    var { azureLoginState, instance } = EntraHook(false, toast.current)

    PrimeReact.ripple = true;

    let menuClick = false;
    let mobileTopbarMenuClick = false;

    var [selectedParty, setSelectedParty] = useState(null)
    var [contestationPeriodID, setContestationPeriodID] = useState(null)
    var [partyExecutiveTermID, setPartyExecutiveTermID] = useState(null)
    var [contestationPeriod, setContestationPeriod] = useState(null)

    var [selectedCanditate, setSelectedCanditate] = useState(null)
    var [isOnlyView, setIsOnlyView] = useState(false);
    var [isEditParty, setIsEditParty] = useState(false);
    var [isPoliticalCandidate, setIsPoliticalCandidate] = useState(false);
    const [activeTabIndex, setActiveTabIndex] = useState(globalDelimitation?.activeTabIndex || 0);

    var [cloneParty, setCloneParty] = useState({});



    useEffect(() => {

        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode);
    };

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode);
    };

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    };

    const onToggleMenuClick = (event) => {
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === "overlay") {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            } else if (layoutMode === "static") {
                setStaticMenuInactive((prevState) => !prevState);
            }
        } else {
            setMobileMenuActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarClick = () => {
        menuClick = true;
    };

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        event.preventDefault();
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    };
    const isDesktop = () => {
        return window.innerWidth >= 992;
    };






    async function loadingData() {

        Promise.all([lookupsService.getAll(), lookupsService.statuses()])
            .then(data => {
                var [look_up, status] = data
                setLookUp({ ...look_up, system_status: status?.data || [] })
            })
    }

    useEffect(() => {
        // var politicalPartyHeading = "IEC - Political Party Portal";
        var politicalPartyHeading = "Party / Candidate Portal"
        switch (APP_TYPE) {
            case 'PoliticalParty':
                document.title = politicalPartyHeading;
                setApplicationName(politicalPartyHeading)
            case 'Candidate':
                // politicalPartyHeading = "Party / Candidate Portal"
                document.title = politicalPartyHeading;
                setApplicationName(politicalPartyHeading)
                break;
        }

        if (azureLoginState.isAuthenticated) {



            var _finalUserMenu = null;
            switch (APP_TYPE) {
                case "Results":
                    loadingData();
                    setApplicationName("Results Management")
                    _finalUserMenu = ResultManagementGenerateRoutesAndMenu(azureLoginState)
                    break;
                case 'PoliticalParty':
                    setIsIecEdit(false)
                    var candidate = azureLoginState?.data?.candidate
                    var isPolitical = azureLoginState?.data?.isPoliticalParty
                    var politicalPartyID = azureLoginState?.data?.politicalPartyID

                    if (isPolitical) {
                        _finalUserMenu = PoliticalSelfServiceSiteGenerateRoutesAndMenu(azureLoginState)
                        setSelectedParty({ politicalPartyID: politicalPartyID,isParty:true })
                    } else {
                        if (candidate) {
                            candidate.isCandidate=true;
                            candidate.event = {
                                eventID: candidate.eventID,
                                name: candidate.eventName,
                                isNationalDelimitation: candidate.isNationalDelimitation
                            };
                        }
                        setSelectedCanditate(candidate)
                        setApplicationName("Candidate Management")
                        _finalUserMenu = CandidateSiteGenerateRoutesAndMenu(azureLoginState)
                    }


                    break;
                default:
                    loadingData();
                    setSelectedParty(null)
                    setSelectedCanditate(null)
                    setApplicationName("IEC Elector Management")
                    _finalUserMenu = CentalSiteGenerateRoutesAndMenu(azureLoginState)

                    break;
            }


            setFinalUserMenu(_finalUserMenu)
        }

    }, [azureLoginState])


    const addClass = (element, className) => {
        if (element.classList) element.classList.add(className);
        else element.className += " " + className;
    };

    const removeClass = (element, className) => {
        if (element.classList) element.classList.remove(className);
        else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };

    const wrapperClass = classNames("layout-wrapper", {
        "layout-overlay": layoutMode === "overlay",
        "layout-static": layoutMode === "static",
        "layout-static-sidebar-inactive": staticMenuInactive && layoutMode === "static",
        "layout-overlay-sidebar-active": overlayMenuActive && layoutMode === "overlay",
        "layout-mobile-sidebar-active": mobileMenuActive,
        "p-input-filled": inputStyle === "filled",
        "p-ripple-disabled": ripple === false,
        "layout-theme-light": layoutColorMode === "light",
    });

    const [showEditRegistration, setShowEditRegistration] = useState(false);
    const [groupEventInfo, setgroupEventInfo] = useState(() => {
        return JSON.parse(localStorage.getItem('groupEventInfo')) || null
    });
    const [AllbyElectionEvents, setAllbyElectionEvents] = useState(() => {
        return JSON.parse(localStorage.getItem('AllbyElectionEvents')) || null
    });
    const [allEventsPerGroup, setallEventsPerGroup] = useState(() => {
        return JSON.parse(localStorage.getItem('allEventsPerGroup')) || null
    });
    const [selectedEventName, setselectedEventName] = useState(() => {
        return JSON.parse(localStorage.getItem('selectedEventName')) || null
    });
    const [allGroups, setallGroups] = useState(() => {
        return JSON.parse(localStorage.getItem('allGroups')) || null
    });
    const [isOfficeView, setIsOfficeView] = useState(() => {
        return JSON.parse(localStorage.getItem('isOfficeView')) || false
    });

    const [officeOnly, setOfficeOnly] = useState(() => {
        return JSON.parse(localStorage.getItem('officeOnly')) || false
    });
  
    const [userInfo, setUserInfo] = useState(() => {
        return JSON.parse(localStorage.getItem('userInfo')) || null
    });


    useEffect(() => {
        if (groupEventInfo) {
            localStorage.setItem("groupEventInfo", JSON.stringify(groupEventInfo))
        }
        if (allEventsPerGroup) {
            localStorage.setItem("allEventsPerGroup", JSON.stringify(allEventsPerGroup))
        }
        if (selectedEventName) {
            localStorage.setItem("selectedEventName", JSON.stringify(selectedEventName))
        }
        if (allGroups) {
            localStorage.setItem("allGroups", JSON.stringify(allGroups))
        }
        if (officeOnly) {
            localStorage.setItem("officeOnly", JSON.stringify(officeOnly))
        }
        if (isOfficeView) {
            localStorage.setItem("isOfficeView", JSON.stringify(isOfficeView))
        }

        if (userInfo) {
            localStorage.setItem("userInfo", JSON.stringify(userInfo))
        }
    }, [allEventsPerGroup, groupEventInfo, selectedEventName, userInfo, isOfficeView, officeOnly, allGroups])




    return (

        <AppDB.Provider value={{
            menuRootName, setMenuRootName,
            activeTabIndex,
            setActiveTabIndex,
            officeOnly, setOfficeOnly,
            userInfo, setUserInfo,
            isPoliticalCandidate, setIsPoliticalCandidate,
            isIecEdit, setIsIecEdit,
            isOfficeView, setIsOfficeView,
            applicationName,
            allEventsPerGroup, setallEventsPerGroup,
            groupEventInfo, setgroupEventInfo,
            selectedEventName, setselectedEventName,
            showEditRegistration, setShowEditRegistration,
            setallGroups, allGroups,
            lookUp, finalUserMenu, globalDelimitation, setGlobalDelimitation, refreshingApplication, seRefreshingApplication, currrentApplicationScreen, setCurrrentApplicationScreen, permission, setPermission, toast: toast.current
        }}>
            <LanguageControl  >

                <CandidateDBContext.Provider value={{ selectedCanditate, setSelectedCanditate, isOnlyView, setIsOnlyView, isIecEdit, setIsIecEdit }}>
                    <PoliticalPartyDBContext.Provider value={{ refresh_politicalParties, setRefresh_PoliticalParties, partyExecutiveTermID, setPartyExecutiveTermID, selectedParty, setSelectedParty, contestationPeriod, setContestationPeriod, contestationPeriodID, setContestationPeriodID, isOnlyView, setIsOnlyView, isIecEdit, setIsIecEdit }}>

                        <Toast ref={toast} position="top-center" />
                        {/* <PageNoModules visible={true}/> */}
                        <LoadingModules visible={azureLoginState.pageLoding} />
                        <div className={wrapperClass} onClick={onWrapperClick}>
                            {!azureLoginState.isAuthenticated ? (
                                <Route path="/" component={Login} />
                            ) : (
                                <>
                                    <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

                                    <AppTopbar azureLoginState={azureLoginState} onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode} mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />
                                    <div className="layout-sidebar" onClick={onSidebarClick}>
                                        <AppMenu isPoliticalParty={azureLoginState?.data?.isPoliticalParty} isLoggedIn={azureLoginState.isAuthenticated} model={finalUserMenu.menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode}></AppMenu>
                                    </div>
                                    <div className="layout-main-container">
                                        <div className="layout-main">

                                            {Object.keys(finalUserMenu.routes).map((routePath, index) => {
                                                var routeData = finalUserMenu.routes[routePath]
                                                var applicationTypeID = routeData?.applicationTypeID
                                                var Component = routeData?.component
                                                var group = routeData?.group
                                                var screenType = routeData?.screenType
                                                var action = routeData?.action
                                                var subModules = routeData?.subModules
                                                if (group === null || group?.trim() === "" || group === undefined) {

                                                    // routeGroup
                                                    return (<Route exact key={index} path={routePath} render={() => (<ScreenLoader
                                                        setPermission={setPermission}
                                                        action={action}
                                                        subModules={subModules}
                                                        group={group}
                                                        setGlobalDelimitation={setGlobalDelimitation}
                                                    >
                                                        <Component />
                                                    </ScreenLoader>)} />)
                                                } else if (group === "Objections") {
                                                    // routeGroup
                                                    return (<Route exact key={index} path={routePath} render={() => (<ScreenLoader
                                                        setPermission={setPermission}
                                                        action={action}
                                                        subModules={subModules}
                                                        screenType={screenType}
                                                        setCurrentApplicationScreen={setCurrrentApplicationScreen}
                                                        group={group}
                                                        setGlobalDelimitation={setGlobalDelimitation}
                                                    >
                                                        <Component channelCategoryID={null} applicationTypeID={applicationTypeID} />
                                                    </ScreenLoader>)} />)
                                                } else if (group === "Applications") {
                                                    return (<Route exact key={index} path={routePath} render={() => (<ScreenLoader
                                                        setPermission={setPermission}
                                                        action={action}
                                                        subModules={subModules}
                                                        screenType={screenType}
                                                        setCurrentApplicationScreen={setCurrrentApplicationScreen}
                                                        group={group}
                                                        setGlobalDelimitation={setGlobalDelimitation}
                                                    >
                                                        <Applications channelCategoryID={null} applicationTypeID={applicationTypeID} />
                                                    </ScreenLoader>)} />)
                                                } else if (group === "UnassistedApplications") {
                                                    return (<Route exact key={index} path={routePath} render={() => (<ScreenLoader
                                                        setPermission={setPermission}
                                                        action={action}
                                                        subModules={subModules}
                                                        screenType={screenType}
                                                        setCurrentApplicationScreen={setCurrrentApplicationScreen}
                                                        group={group}
                                                        setGlobalDelimitation={setGlobalDelimitation}
                                                    >
                                                        <Applications channelCategoryID={CHANNEL_CATEGORY_UNASSISTED} applicationTypeID={applicationTypeID} />
                                                    </ScreenLoader>)} />)
                                                }
                                            })}


                                            {azureLoginState.isAuthenticated && (<AppFooter
                                                dataSource={azureLoginState?.data?.system?.dataSource}
                                                environmentName={azureLoginState?.data?.system?.environmentName}
                                            />)}


                                        </div>
                                    </div>
                                </>
                            )}

                            <AppConfig rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange} layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} />

                            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                                <div className="layout-mask p-component-overlay"></div>
                            </CSSTransition>
                        </div>
                    </PoliticalPartyDBContext.Provider>
                </CandidateDBContext.Provider>
            </LanguageControl>
        </AppDB.Provider>

    );
};

export default App;
